import ReactOnRails from 'react-on-rails';
import '../src/styles/contracts-page.sass';
import ContractsPage from "../bundles/ContractsPage";

// This is how react_on_rails can see the HelloWorld in the browser.
ReactOnRails.register({ ContractsPage });
